/** @type {import('@nuxt/types').Plugin} */
export default ({ $sentry, app }) => {
    const { $tidalAuth } = app;
    if ($tidalAuth.isLoggedIn()) {
        const userInfo = $tidalAuth.user;
        $sentry.setUser({
            id: String(userInfo?.id),
            username: userInfo?.userName,
        });
    }
};
